export class Rut {
  private readonly _value: string;

  private constructor(value: string) {
    this._value = value;
  }

  public static create(rawRut: string): Rut {
    if (!rawRut || typeof rawRut !== 'string') {
      throw new Error('El RUT no puede estar vacío.');
    }

    const clean = Rut.clean(rawRut);

    if (!Rut.isValidFormat(clean)) {
      throw new Error('El formato del RUT no es válido.');
    }

    if (!Rut.verifyCheckDigit(clean)) {
      throw new Error('El dígito verificador del RUT es incorrecto.');
    }

    return new Rut(clean);
  }

  public get value(): string {
    return this._value;
  }

  public get formatted(): string {
    const [body, dv] = this._value.split('-');
    if (!body || !dv) return this._value;

    const formattedBody = body.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return `${formattedBody}-${dv}`;
  }

  public static clean(raw: string): string {
    return raw.replace(/[^0-9kK]/g, '').toUpperCase().replace(/^(\d+)([0-9K])$/, '$1-$2');
  }

  public static format(raw: string): string {
    const cleaned = Rut.clean(raw);
    const [body, dv] = cleaned.split('-');
    if (!body || !dv) return cleaned;
    const formattedBody = body.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return `${formattedBody}-${dv}`;
  }

  private static isValidFormat(cleaned: string): boolean {
    const regex = /^\d{7,8}-[\dK]$/;
    return regex.test(cleaned);
  }

  private static verifyCheckDigit(cleaned: string): boolean {
    const [body, expectedDv] = cleaned.split('-');
    if (!body || !expectedDv) return false;

    let sum = 0;
    let multiplier = 2;

    for (let i = body.length - 1; i >= 0; i--) {
      sum += parseInt(body.charAt(i), 10) * multiplier;
      multiplier = multiplier === 7 ? 2 : multiplier + 1;
    }

    const remainder = 11 - (sum % 11);
    let calculatedDv = '';

    if (remainder === 11) {
      calculatedDv = '0';
    } else if (remainder === 10) {
      calculatedDv = 'K';
    } else {
      calculatedDv = String(remainder);
    }

    return calculatedDv === expectedDv;
  }
}
